import {
  Component,
  OnDestroy,
} from '@angular/core'
import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'

export type ParamsType<DATA, PROPS, FIELD extends keyof DATA> = ICellRendererParams<DATA, DATA[FIELD]> & PROPS

@Component({
  template: '',
  styles: '',
})
export abstract class BaseCellComponent<
  DATA,
  PROPS,
  FIELD extends keyof DATA,
> implements ICellRendererAngularComp, OnDestroy
{
  params: ParamsType<DATA, PROPS, FIELD>
  field: FIELD | undefined
  headerName: string

  agInit(params: ParamsType<DATA, PROPS, FIELD>): void {
    this.refresh(params)
    this.init()
  }


  refresh(params: ParamsType<DATA, PROPS, FIELD>) {
    this.destroy()
    this.params = params
    this.field = this.params.colDef?.field as FIELD | undefined
    this.headerName = this.params.colDef?.headerName ?? ''
    return true
  }

  ngOnDestroy(): void {
    this.destroy()
    this.onClose()
  }

  destroy(): void { /* empty */ }
  init() { /* empty */ }
  onOpen() { /* empty */ }
  onClose() { /* empty */ }
}

/* eslint-disable  @typescript-eslint/no-unused-vars */
export type DataForCell<C>  = C extends BaseCellComponent<infer D, infer P, infer F> ? D : never
export type PropsForCell<C> = C extends BaseCellComponent<infer D, infer P, infer F> ? P : never
export type FieldForCell<C> = C extends BaseCellComponent<infer D, infer P, infer F> ? F : never
 